import React, { useState } from "react";
import styles from "./LandingPage2.module.scss";

import signupImage from "../../../Components/assets/Images/signupImagelandingpage.svg";
import docsrequiredimage from "../../../Components/assets/Images/docsrequiredimage.svg";
import congrzimage from "../../../Components/assets/Images/congrzimage.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";

const features = [
  "Effortless Account Opening",
  "Data Privacy Protection",
  "Secure Document Verification",
  "User-Friendly Interface",
  "Regulatory Compliance",
  "Single Sign On",
  "Convenient Market Access",
];

export default function LandingPage2() {
  const [selectedTab, setSelectedTab] = useState(1);
  const navigate = useNavigate();
  return (
    <section className={styles.buildWrapper}>
      <div className={styles.titleContainer}>
        <div className={styles.titleText}>
          Get Started in 3 Simple Steps — No Hassle
        </div>
        <div className={styles.descText}>
          Experience hassle-free account opening with Firstock's tailored NRI
          onboarding process. Unlock global financial opportunities with ease.
        </div>
      </div>

      <div className={styles.howitWorksWrapper}>
        <div className={styles.tabsWrapper}>
          <div className={styles.leftContainer}>
            <img
              src={
                selectedTab === 1
                  ? signupImage
                  : selectedTab === 2
                  ? docsrequiredimage
                  : congrzimage
              }
              alt=""
              className={styles.leftImage}
            />
          </div>
          <div className={styles.rightContainer}>
            <div className={styles.tabsSection}>
              <div
                className={styles.tab}
                style={{ borderLeft: selectedTab === 1 ? "" : "0px" }}
              >
                <div
                  className={styles.tabTitle}
                  onClick={() => {
                    setSelectedTab(1);
                  }}
                >
                  Fill in Your Basic Details
                  <KeyboardArrowDownIcon
                    style={{
                      fontSize: "30px",
                      transform:
                        selectedTab === 1 ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "all 0.3s ease",
                    }}
                  />
                </div>
                <div
                  className={styles.tabDesc}
                  style={{
                    maxHeight: selectedTab === 1 ? "200px" : "0px",
                  }}
                >
                  Enter your personal and NRI-specific details to begin the
                  process. It’s a quick and easy way to set up your account.
                </div>
              </div>
              <div
                className={styles.tab}
                style={{ borderLeft: selectedTab === 2 ? "" : "0px" }}
              >
                <div
                  className={styles.tabTitle}
                  onClick={() => {
                    setSelectedTab(2);
                  }}
                >
                  Upload Required Documents
                  <KeyboardArrowDownIcon
                    style={{
                      fontSize: "30px",
                      transform:
                        selectedTab === 2 ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "all 0.3s ease",
                    }}
                  />
                </div>
                <div
                  className={styles.tabDesc}
                  style={{
                    maxHeight: selectedTab === 2 ? "200px" : "0px",
                  }}
                >
                  Upload your PAN, passport, visa, and other documents online.
                  Your details are safe and fully protected.
                </div>
              </div>
              <div
                className={styles.tab}
                style={{ borderLeft: selectedTab === 3 ? "" : "0px" }}
              >
                <div
                  className={styles.tabTitle}
                  onClick={() => {
                    setSelectedTab(3);
                  }}
                >
                  Account Activation
                  <KeyboardArrowDownIcon
                    style={{
                      fontSize: "30px",
                      transform:
                        selectedTab === 3 ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "all 0.3s ease",
                    }}
                  />
                </div>
                <div
                  className={styles.tabDesc}
                  style={{
                    maxHeight: selectedTab === 3 ? "200px" : "0px",
                  }}
                >
                  We’ll check your documents and get your NRI account ready.
                  You’ll get a confirmation once everything is done.
                </div>
              </div>
            </div>
            <div className={styles.buttonSection}>
              <div
                className={styles.getStartedButton}
                onClick={() => {
                  navigate("/email");
                }}
              >
                Sign Up Today
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M9.33333 3.33594L14 8.0026M14 8.0026L9.33333 12.6693M14 8.0026L2 8.0026"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
